
export default {
  add_employee: 'Agregar empleado',
  employee_fields: 'Datos del empleado',
  birthdate: 'Fecha de nacimiento',
  personal_data: 'Datos personales',
  employment_data: 'Datos laborales',
  created_employee: 'Empleado creado exitosamente',
  import_employees: 'Importar colaboradores',
  download_template: 'Descargar plantilla',
  download_docs: 'Descargar instructivo',
  // tslint:disable-next-line:max-line-length
  upload_description: 'Cargue un archivo excel (.xls/.xlsx) o csv (.csv) que contenga los datos de sus colaboradores. Esta acción actualizará su base total de colaboradores, por lo que debe agregar la base completa de colaboradores disponibles.',
  select_file_to_upload: 'Seleccionar archivo a cargar',
  select_file: 'Seleccionar archivo',
  summary: 'Resumen del proceso',
  fix_errors: 'Corrección de errores',
  total_updated: 'Se actualizarán {total} colaboradores.',
  total_inserted: 'Se agregarán {total} colaboradores.',
  total_deleted: 'Se desactivarán {total} colaboradores.',
  total_failed: 'Se han encontrado {total} registros con errores.',
  file_updated: 'Archivo actualizado',
  save_changes: 'Guardar cambios',
  error_fix: 'Corregir errores',
  if_any: 'De existir',
  process_cancelled: 'Proceso cancelado',
  massive_success: 'Carga masiva ejecutada exitosamente.',
  massive_upload: 'Carga masiva',
  download_log: 'Descargar log',
  id: 'Id',
  name: 'Nombre',
  last_name: 'Apellido',
  city: 'Ciudad',
  email: 'Correo',
  action: 'Acción',
  employment: 'Empleo',
  employees: 'Colaboradores',
  list_employees: 'Listado de colaboradores',
  look_for: 'Buscar un empleado',
  filter_by: 'Filtrar por...',
  no_data: 'No hay colaboradores para mostrar',
  modal_enable: '¿Desea habilitar el empleado?',
  modal_disable: '¿Desea Inhabilitar el empleado?',
  modal_action: 'Realizar acción',
  status: 'Estado',
  edit_employee: 'Editar empleado',
  enable_title: 'Habilitar empleado',
  disable_title: 'Deshabilitar empleado',
  // tslint:disable-next-line:max-line-length
  enable_text: '¿Seguro que desea habilitar a este empleado? Tras ello, el empleado tendrá acceso al sistema.',
  // tslint:disable-next-line:max-line-length
  disable_text: '¿Seguro que desea deshabilitar a este empleado? Tras ello, el empleado no tendrá acceso al sistema.',
  employment_at: '{title} en',
  updated_employee: 'Empleado actualizado exitosamente'
}
